import { render, staticRenderFns } from "./RelationDetails.vue?vue&type=template&id=4f03b096&scoped=true"
import script from "./RelationDetails.vue?vue&type=script&lang=ts"
export * from "./RelationDetails.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f03b096",
  null
  
)

export default component.exports